import { Cartao } from '../../../components/ListaDeDados'
import { CamposDeClassificacao } from './CamposDeClassificacao'
import { CamposDoSistema } from './CamposDoSistema'
import type { FormularioNovaGmud, PropsDosCampos } from './esquema'
import type { Control } from 'react-hook-form'

interface Props extends PropsDosCampos {
  emergencial: boolean
  control: Control<FormularioNovaGmud>
}

/**
 * Etapa 1 — classificar a mudança.
 *
 * Dois cartões e não um só: são duas perguntas diferentes, e o formulário único do sistema
 * anterior misturava "de onde isso veio" com "onde isso vai mexer" numa coluna de quatorze
 * campos. Quem não é de TI lê a tela de cima a baixo uma vez; o agrupamento é o que permite
 * pular o que não se aplica.
 *
 * @param props registro do formulário, erros, se a prioridade é emergencial e o controle —
 *     o sub-módulo precisa acompanhar o módulo escolhido
 * @returns o conteúdo da primeira etapa
 */
export function EtapaClassificacao({ register, errors, emergencial, control }: Props) {
  return (
    <div className="space-y-5">
      <Cartao titulo="Origem e prioridade" descricao="Por que esta mudança está sendo aberta e quanto ela corre.">
        <CamposDeClassificacao register={register} errors={errors} emergencial={emergencial} />
      </Cartao>

      <Cartao titulo="Sistema e responsável" descricao="Onde a mudança será aplicada e quem responde por ela.">
        <CamposDoSistema register={register} errors={errors} control={control} />
      </Cartao>
    </div>
  )
}
